import { useContext } from 'react';
import { CreateAccountContext } from '../context/createAccount';

export const useCreateAccount = () => useContext(CreateAccountContext);
